module.exports = __webpack_public_path__ + "static/media/generic-men.cc328adf.jpg";